export default __webpack_public_path__ + "static/media/iconInfo.d2c89729.svg";